import AdminInvoiceItemsList from "../components/AdminInvoiceItemsList";
import { useCallback, useEffect, useState } from "react";
import { useGetOrganizations } from "../operations/queries/getOrganizations";
import { useLazyGetInvoiceItems } from "../operations/queries/getInvoiceItems";
import { useMarkInvoiceItemsAsSent } from "../operations/mutations/markInvoiceItemsAsSent";

const AdminInvoiceItemsListContainer = () => {
  const [paginationInfo, setPaginationInfo] = useState({ pageSize: 0, pageIndex: 0 });
  const [orgFilter, setOrgFilter] = useState<string>();
  const [selectedInvoiceItems, setselectedInvoiceItems] = useState<string[]>([]);
  const { mutate: markInvoiceItemsAsSentMutate, status: markInvoiceItemsAsSentStatus } = useMarkInvoiceItemsAsSent();

  const currentListVariables = {
    skip: paginationInfo.pageIndex * paginationInfo.pageSize,
    take: paginationInfo.pageSize,
    orgId: orgFilter,
  };

  const { data: organizations } = useGetOrganizations();
  const { getInvoiceItems, data: invoiceItems, status: getInvoiceItemsStatus } = useLazyGetInvoiceItems();

  const handlePageInfoChange = useCallback((pageIndex: number, pageSize: number) => {
    if (pageSize !== paginationInfo.pageSize || pageIndex !== paginationInfo.pageIndex) {
      setPaginationInfo({ pageSize, pageIndex });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOrgFilter = (orgId: string) => {
    if (orgId !== undefined) setOrgFilter(orgId);
    setPaginationInfo({ ...paginationInfo, pageIndex: 0 });
  };

  useEffect(() => {
    if (paginationInfo.pageSize > 0) {
      getInvoiceItems({
        variables: currentListVariables,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationInfo.pageSize, paginationInfo.pageIndex, orgFilter]);

  const handleInvoiceItemSelectChange = (id: string, checked: boolean) => {
    if (checked) {
      setselectedInvoiceItems([...selectedInvoiceItems, id]);
    } else {
      setselectedInvoiceItems(selectedInvoiceItems.filter((item) => item !== id));
    }
  };

  const handleMarkAsSent = () => {
    markInvoiceItemsAsSentMutate({
      variables: {
        ids: selectedInvoiceItems,
      },
    }).then(() => {
      setselectedInvoiceItems([]);
    });
  };

  return (
    <AdminInvoiceItemsList
      isInvoiceItemsLoading={getInvoiceItemsStatus.loading}
      invoiceItems={invoiceItems && invoiceItems.invoiceItems?.items}
      organizations={organizations && organizations.organizations}
      pageCount={invoiceItems && Math.ceil((invoiceItems.invoiceItems?.totalCount ?? 0) / paginationInfo.pageSize)}
      onPageInfoChange={handlePageInfoChange}
      onOrgFilter={handleOrgFilter}
      onInvoiceItemSelectChange={handleInvoiceItemSelectChange}
      selectedInvoiceItems={selectedInvoiceItems}
      onMarkAsSent={handleMarkAsSent}
      markInvoiceItemsAsSentStatus={markInvoiceItemsAsSentStatus}
    ></AdminInvoiceItemsList>
  );
};

export default AdminInvoiceItemsListContainer;
